import { Group, HowToReg, Person } from "@mui/icons-material";
import PrivilegesKeydriveTabOne from "./PrivilegesKeydriveTabOne";
import { UserPermission } from "../../../../model/UserModel";
import { useTranslation } from "react-i18next";
import { StatePrivilegesTypes } from "../WorkSpacePermissions";
import { GroupPermission } from "../../../../model/GroupModel";
import PrivilegesKeydriveTabTwo from "./PrivilegesKeydriveTabTwo";
import { CircularProgress } from "@mui/material";
import { KeyDriveTab2 } from "../../../../components/KeydriveComponents/Tabs/KeydriveTab2";
import { KeyDrivePageContainer } from "../../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";
import { PermissionTargetType } from "../../../../enums/PermissionTargetType";

interface IPrivilegesStateDefault {
    workspaceName: string;
    allUsersMemory: UserPermission[];
    allGroupsMemory: GroupPermission[];
    loadingUsers: boolean;
    setSearchFilter: (set: string) => void;
    tableUserHeaders: string[];
    tableGroupHeaders: string[];
    targetType: PermissionTargetType;
    setTargetType: (set: number) => void;
    setPrivilegesState?: (set: { state: StatePrivilegesTypes, id: string, permissionType: number }) => void;
    isItemPage?: boolean;
    ownerId: string;
    hasFolderChild: boolean;
}

function PrivilegesStateDefault({
    allUsersMemory,
    loadingUsers,
    setSearchFilter,
    tableUserHeaders,
    tableGroupHeaders,
    targetType,
    workspaceName,
    setTargetType,
    setPrivilegesState,
    allGroupsMemory,
    isItemPage,
    ownerId,
    hasFolderChild
}: IPrivilegesStateDefault) {

    const { t } = useTranslation();

    return (
        <KeyDrivePageContainer icon={<HowToReg fontSize='large' sx={{color: "#22638D"}}/>} title={t("Sidebar.Privileges")} subtitle={`${t("Privileges.VerifyUserPrivilegeCaption")} ${isItemPage ? t("Privileges.Item") : t("Privileges.Workspace")} ${workspaceName}.`}>
            <KeyDriveTab2
                icon1={<Person />}
                icon2={<Group />}
                label1={t("Privileges.Users")}
                label2={t("Privileges.Groups")}
                onChange={(_, i) => { setTargetType(i) }}
                numberOfTabs={2}
            >
                { loadingUsers ? <CircularProgress /> : (
                    <>
                        <PrivilegesKeydriveTabOne 
                            allUsersMemory={allUsersMemory}
                            loadingUsers={loadingUsers}
                            setSearchFilter={setSearchFilter}
                            tableUserHeaders={tableUserHeaders}
                            targetType={targetType}
                            setPrivilegesState={setPrivilegesState}
                            ownerId={ownerId}
                            hasFolderChild={hasFolderChild}
                        />
                        <PrivilegesKeydriveTabTwo 
                            allGroupsMemory={allGroupsMemory}
                            loadingUsers={loadingUsers}
                            setSearchFilter={setSearchFilter}
                            tableHeaders={tableGroupHeaders}
                            targetType={targetType}
                            setPrivilegesState={setPrivilegesState}
                        />
                    </>
                ) }

            </KeyDriveTab2>
        </KeyDrivePageContainer>
    );
}

export default PrivilegesStateDefault;